import {
  BREEDER_DASHBOARD_PATH,
  BREEDER_BASE_APPLICATIONS_PATH,
  BREEDER_BASE_WAITLIST_PATH,
  BREEDER_PAST_FAMILIES_PATH,
  BREEDER_MESSAGES_PATH,
  BREEDER_LITTERS_PATH,
  BREEDER_SIRES_DAMS_PATH,
  BREEDER_PAYMENTS_PATH
} from 'dpl/shared/constants/urls';
import { breederAppPaymentSettingsShowQueryDefinition } from 'dpl/shared/breeder/payments/utils/queryDefinitions';
import useCurrentUser from 'dpl/common/hooks/useCurrentUser';
import useNotificationCounts from 'dpl/shared/hooks/useNotificationCounts';
import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import { get } from 'dpl/shared/utils/object';

// TODO: might be able to remove 'pathname' parameter when react-router is upgraded
export default function useDashboardRoutes(pathname = window.location.pathname) {
  const currentUser = useCurrentUser();
  const paymentsEnabled = get(currentUser, 'value.data.payments_enabled', false);

  const { notifications } = useNotificationCounts();
  const breederApproved = currentUser.value.data.approved;

  const breederProfileId = get(currentUser, 'value.data.breeder_profile_id');

  const paymentSettingsShowResource = useResourceQuery({
    ...breederAppPaymentSettingsShowQueryDefinition(breederProfileId),
    config: {
      enabled: Boolean(breederProfileId)
    }
  });

  const routes = [{
    icon: 'house',
    path: BREEDER_DASHBOARD_PATH,
    title: 'Overview',
    locked: false
  }, {
    icon: 'application',
    path: BREEDER_BASE_APPLICATIONS_PATH,
    title: 'Applications',
    notificationsCount: breederApproved ? notifications.unseenApplicationsCount : 0,
    locked: !breederApproved
  }, {
    icon: 'notebook',
    path: BREEDER_BASE_WAITLIST_PATH,
    title: 'Waitlist',
    locked: false
  }, {
    icon: 'family',
    path: BREEDER_PAST_FAMILIES_PATH,
    title: 'My Owners',
    locked: false
  }, {
    icon: 'message',
    path: BREEDER_MESSAGES_PATH,
    title: 'Messages',
    notificationsCount: notifications.unreadMessagesCount,
    locked: !breederApproved
  }, {
    icon: 'litter',
    path: BREEDER_LITTERS_PATH,
    title: 'Litters',
    locked: false
  }, {
    icon: 'dog',
    path: BREEDER_SIRES_DAMS_PATH,
    title: 'Sires & Dams',
    locked: false
  }];

  let paymentsCount = notifications.outstandingBipsCount || 0;
  if (paymentSettingsShowResource.isSuccess && !paymentSettingsShowResource.value.data.id) {
    paymentsCount++;
  }

  if (paymentsEnabled) {
    routes.push({
      icon: 'money-payment',
      path: BREEDER_PAYMENTS_PATH,
      title: 'Payments',
      notificationsCount: paymentsCount,
      locked: !breederApproved
    });
  }

  return routes.map(r => ({ ...r, isActive: pathname.startsWith(r.path) }));
}
